<template>
  <v-container fluid class="pa-0">
    <v-card class="v-card--material pa-3 ma-2 rounded-lg" elevation="2">
      <v-row no-gutters>
        <v-col cols="12" md="6" lg="4" sm="6" xs="12" class="my-0 py-0">
          <div class="d-flex grow flex-wrap">
            <div class="font-weight-regular headline text-decoration-underline text-capitalize">
              Create / View Schedule
            </div>
          </div>
        </v-col>
        <v-col>
          <v-card-actions>
            <router-link slot="right" :to="{ name: 'amsSchedulingDashboard' }">
              <v-btn elevation="1" absolute right top>
                <v-icon left>mdi-arrow-left</v-icon>back</v-btn>
            </router-link>
          </v-card-actions>
        </v-col>
      </v-row>

      <div class="pt-4">
        <div class="">
          <!-- <span class="subtitle-2">Create / View Schedule</span> -->
          <v-row>
            <v-col cols="12" md="3" sm="2" xs="12" v-if="isSuperAdmin">
              <v-autocomplete key="id" :items="zoneList" v-model="zoneID" item-text="name" item-value="id"
                @change="getAcademicManagerList()" :error-messages="zoneErrorMes">
                <template v-slot:label> Zone </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" md="4" sm="2" xs="12" v-if="isSuperAdmin">
              <v-autocomplete name="id" :items="academicManagerList" v-model="academicManagerID" item-value="amUserId"
                item-text="academicManagerName" @change="getRoundData()" :error-messages="acmaErrorMes">
                <template v-slot:label> Academic Manager </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" md="4" lg="4" sm="4" xs="12">
              <v-autocomplete name="round" v-model="selectedRound" :items="formattedPeriods" required item-value="id"
                item-text="period">
                <template v-slot:label>
                  Round Duration
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" md="3" lg="3" sm="3" xs="12">
              <v-autocomplete v-model="selectedStatus" :items="schedulingStatus" item-text="status" item-value="id"
                key="id" required>
                <template v-slot:label>
                  Status
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" md="3" lg="3" sm="3" xs="12">
              <div class="d-flex caption">
                <v-btn small id="apply" color="success" elevation="1" type="submit" class="ml-2 mt-5"
                  @click="filterTable()">
                  <v-icon left size="18"> mdi-text-box-check-outline </v-icon>
                  Filter
                </v-btn>
                <v-btn small elevation="1" type="reset" @click="resetAll()" class="ml-2 mt-5">
                  <v-icon left size="18"> mdi-restart</v-icon> Clear
                </v-btn>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12" lg="12" sm="12" xs="12">
              <template>
                <v-data-table :headers="headers" :items="filteredData" item-key="id" disable-pagination
                  :hide-default-footer="true">

                  <template v-slot:[`item.round`]="{ item }">
                    {{ 'Round' + ' ' + item.round }}
                  </template>

                  <template v-slot:[`item.status`]="{ item }">
                    <v-btn class="px-2 ml-1 ma-1" outlined min-width="0" small @click="openPopup(item)"
                      :style="{ width: '200px', height: '30px' }" color="primary">
                      {{ item.status }}
                    </v-btn>
                  </template>

                  <template v-slot:[`item.schedule`]="{ item }">
                    <v-btn class="px-2 ml-1 ma-1" outlined min-width="0" small @click="handleScheduleClick(item)"
                      :style="{ width: '150px', height: '30px' }" color="primary">
                      {{ getScheduleLabel(item.status) }}
                    </v-btn>
                  </template>
                </v-data-table>
              </template>
            </v-col>
          </v-row>
        </div>

        <v-dialog v-model="statusDialog" max-width="900px">
          <div class="d-flex justify-content-between pa-3 v-card--material v-card v-sheet theme--light">
            <span class="subtitle-2 text-h6">View Details</span>
            <v-btn icon @click="() => {
              (statusDialog = false)
            }">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
          <div class="pa-3 bg-white">
            <v-data-table :headers="detailsPopUpHeader" :items="popUpDetail" item-key="id" disable-pagination
              :hide-default-footer="true"></v-data-table>
          </div>
        </v-dialog>
      </div>
    </v-card>
  </v-container>
</template>

<script>
import stores from '../../../stores'
import constants from '../../../utils/constants'
import moment from 'moment'

export default {
  name: 'amsSchedulingDashboard',
  data () {
    return {
      headers: [
        { text: 'Round', value: 'round', align: 'center' },
        { text: 'Start Date-End Date', value: 'formattedDate', align: 'center' },
        { text: 'Status', value: 'status', align: 'center' },
        { text: 'Schedule', value: 'schedule', align: 'center' }
      ],
      detailsPopUpHeader: [
        { text: 'Date', value: 'date', align: 'center' },
        { text: 'Status', value: 'status', align: 'center' },
        { text: 'Reason', value: 'reason', align: 'center' }
      ],
      schedulingStatus: [
        'Not Created Yet',
        'Pending For Approval',
        'Rejected',
        'Approved'
      ],
      amsUserID: stores.user.me.id,
      selectedStatus: '',
      selectedRound: '',
      scheduleData: [],
      filteredData: [],
      statusDialog: false,
      popUpDetail: [],
      academicManagerList: [],
      zoneList: [],
      zoneID: '',
      academicManagerID: '',
      zoneErrorMes: '',
      acmaErrorMes: '',
      isSuperAdmin: false
    }
  },
  created () {
    let userStore = stores.user
    this.isSuperAdmin = userStore.ACL.superAdmin
    if (!this.isSuperAdmin) {
      this.getRoundData()
    }
    this.getZones()
  },
  computed: {
    formattedPeriods () {
      return this.scheduleData.map(period => ({
        period: `${this.formatDate(period.startDate)} - ${this.formatDate(period.endDate)}`,
        ...period
      }))
    }
  },
  mounted () {
    this.filteredData = this.scheduleData
  },
  methods: {
    getScheduleLabel (status) {
      switch (status) {
        case 'Not Created Yet':
          return 'Create'
        case 'Pending For Approval':
          return 'View'
        case 'Rejected':
          return 'Edit'
        case 'Approved':
          return 'View'
        default:
          return ''
      }
    },
    handleScheduleClick (item) {
      let scheduleStatus = this.getScheduleLabel(item.status)
      let shareData = {
        selectedStatus: scheduleStatus,
        roundID: item.roundId,
        roundStartDate: item.startDate
      }
      localStorage.setItem('selectedRoundData', JSON.stringify(shareData))
      this.$router.push({ name: 'amsScheduling' })
      // Handle the button click based on the item's status or other properties
      console.log(`${this.getScheduleLabel(item.status)} button clicked for round ${item.round}`)
    },
    getRoundData: async function () {
      try {
        if (this.academicManagerID) {
          this.amsUserID = this.academicManagerID
        }
        let payload = {
          'amUserId': this.amsUserID
        }
        const { data } = await http.post(`${constants.API_URL}/api/amsScheduling/createSchedule/getRondList`, payload)
        data.sort((a, b) => a.round - b.round)
        // Create the formattedDate key
        this.scheduleData = data.map(item => {
          return {
            ...item,
            formattedDate: `${this.formatDate(item.startDate)} - ${this.formatDate(item.endDate)}`
          }
        })
        this.filteredData = this.scheduleData
      } catch (e) {
        this.isLoading = false
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    formatDate (dateStr) {
      const date = new Date(dateStr)
      const options = { day: 'numeric', month: 'long', year: 'numeric' }
      return date.toLocaleDateString('en-GB', options)
    },
    filterTable () {
      try {
        this.filteredData = this.scheduleData.filter(item => {
          const matchesRound = this.selectedRound ? item.formattedDate === this.selectedRound : true
          const matchesStatus = this.selectedStatus ? item.status === this.selectedStatus : true
          return matchesRound && matchesStatus
        })
      } catch (error) {
        console.log('error ====>', error)
      }
    },
    resetAll () {
      this.selectedRound = ''
      this.selectedStatus = ''
      this.filteredData = this.scheduleData
      this.zoneID = ''
      this.academicManagerList = []
      this.academicManagerID = ''
      if (this.isSuperAdmin) {
        this.scheduleData = []
        this.filteredData = []
      }
    },
    openPopup: async function (item) {
      console.log('item ===>', item)
      let payload = {
        roundId: item.roundId
      }
      const { data } = await http.post(`${constants.API_URL}/api/amsScheduling/createSchedule/getRoundStatusLog`, payload)
      console.log('data ########', data)
      this.popUpDetail = data
      for (const item of this.popUpDetail) {
        item.date = moment(item.date).format('DD/MM/YYYY')
      }
      this.statusDialog = true
    },
    errMsg (msg) {
      console.log('errMsg msg ====>', msg)
      // return this.$dialog.error({
      //   text: msg,
      //   title: 'Error'
      // })
    },
    getZones: async function () {
      try {
        const response = await http.get(
          `${constants.API_URL}/api/get/zones`
        )
        this.zoneList = response.data
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.lock = false
        this.hasClicked = false
        this.$dialog.notify.info(errorMessage, {
          position: 'top-right',
          color: 'error',
          timeout: 2000
        })
      }
    },
    getAcademicManagerList: async function () {
      try {
        this.academicManagerID = ''
        this.allocateCenter = []
        let payload = {}
        payload.zoneId = this.zoneID ? this.zoneID : ''
        const response = await http.post(
          `${constants.API_URL}/api/amsScheduling/configuration/firstAudit/getAcademicManagerList`, payload
        )
        this.academicManagerList = response.data
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.lock = false
        this.hasClicked = false
        this.$dialog.notify.info(errorMessage, {
          position: 'top-right',
          color: 'error',
          timeout: 2000
        })
      }
    }
  }
}
</script>
<style>
.bg-white {
  background-color: #FFFFFF;
}

.justify-content-between {
  justify-content: space-between !important;
}
</style>
